<template>
  <div class="jinNang-detail">
    <div class="content">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/jinNang' }">锦囊</el-breadcrumb-item>
        <el-breadcrumb-item>锦囊详情</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <template>
      <div class="wrapper">
        <div class="main-content">
          <div class="basic-item">
            <div class="title">{{ jinNangDetail.jinNangName }}</div>
            <div class="time">
              创建时间
              {{ dayjs(jinNangDetail.createTime).format('YYYY-MM-DD HH:mm') }}
            </div>
            <div class="sale">
              <div class="price">¥{{ jinNangDetail.price }}</div>
              <div class="buy" @click="buyclick">立即订购</div>
            </div>
          </div>
          <div class="basic-item">
            <div class="subTitle">{{ jinNangDetail.jinNangIntro }}</div>
            <div class="btn-group">
              <div class="btn btn-first">
                胜率 {{ jinNangDetail.selwinidx }}
              </div>
              <div class="btn">最大回撤率 {{ jinNangDetail.maxdrawidx }}</div>
            </div>
          </div>
          <div class="basic-item">
            <div class="subTitle">
              <span class="chu">初</span>
              <span>
                初次交易
                {{
                  dayjs(jinNangDetail.firstTradeTime).format('YYYY-MM-DD HH:mm')
                }}
              </span>
              <span class="jin">近</span>
              <span>
                最近交易
                {{
                  dayjs(jinNangDetail.lastTradeTime).format('YYYY-MM-DD HH:mm')
                }}
              </span>
            </div>
            <div class="card">
              <div
                class="card-item"
                :class="{ greenbj: getSymbol(jinNangDetail.totalYeild) < 0 }"
              >
                <div>总收益</div>
                <div
                  :class="[
                    getSymbol(jinNangDetail.totalYeild) > 0 ? 'c1' : 'c3'
                  ]"
                >
                  {{ jinNangDetail.totalYeild }}
                </div>
              </div>
              <div
                class="card-item"
                :class="{ greenbj: getSymbol(jinNangDetail.weekYeild) < 0 }"
              >
                <div>周收益</div>
                <div
                  :class="[
                    getSymbol(jinNangDetail.weekYeild) > 0 ? 'c1' : 'c3'
                  ]"
                >
                  {{ jinNangDetail.weekYeild }}
                </div>
              </div>
              <div
                class="card-item month"
                :class="{ greenbj: getSymbol(jinNangDetail.monthYeild) < 0 }"
              >
                <div>近一月收益</div>
                <div
                  :class="[
                    getSymbol(jinNangDetail.monthYeild) > 0 ? 'c1' : 'c3'
                  ]"
                >
                  {{ jinNangDetail.monthYeild }}
                </div>
              </div>
            </div>
          </div>
          <div class="chart">
            <div class="chart-filter">
              <div
                v-for="(item, index) in chartFilter"
                :key="index"
                :class="[
                  {
                    'filter-select': index === currentRangeFilterIndex,
                    'filter-item': true
                  }
                ]"
                @click="selectRange(index)"
              >
                {{ item.text }}
              </div>
            </div>
            <div id="yieldChart" class="chart-content"></div>
          </div>
          <div class="trade-item">
            <div class="trade-filter">
              <div
                v-for="(item, index) in tradeFilter"
                :key="index"
                :class="{
                  'trade-filter-item': true,
                  'filter-select': currentTabIndex === index
                }"
                @click="selectTradeFilter(index)"
              >
                {{ item }}
              </div>
            </div>
            <div v-show="currentTabIndex === 0" class="trade-his-item">
              <div class="trade-item-table">
                <div class="table-row table-head">
                  <div></div>
                  <div>名称</div>
                  <div>成交时间</div>
                  <div>成交价</div>
                  <div>成交股数</div>
                  <div>成交额</div>
                  <div>成交占比</div>
                </div>
                <div
                  v-for="(item, index) in this.tradeList"
                  :key="index"
                  class="table-row"
                >
                  <div>
                    <div
                      :class="{
                        'row-in': item.tradeType === 1,
                        'row-out': item.tradeType === 2
                      }"
                    >
                      {{ item.tradeTypeName }}
                    </div>
                  </div>
                  <div>
                    <div>{{ item.secuName }}</div>
                    <div>{{ item.secuCode }}</div>
                  </div>
                  <div>
                    <div>
                      {{ dayjs(item.dealTime).format('YYYY-MM-DD HH:mm:ss') }}
                    </div>
                  </div>
                  <div>
                    <div>{{ item.dealPriceStr }}</div>
                  </div>
                  <div>
                    <div>{{ item.dealNumber }}</div>
                  </div>
                  <div>
                    <div>{{ item.dealAmountStr }}</div>
                  </div>
                  <div>
                    <div>{{ item.dealPosition }}</div>
                  </div>
                </div>
                <div v-show="!pageEnd" class="more" @click="getTradePage">
                  点击查看更多
                </div>
              </div>
            </div>
            <div v-show="currentTabIndex === 1" class="trade-repo-item">
              <div class="repo-summary">
                <div class="summary-item">
                  <div>
                    <span class="ti">总资产</span>
                    <span class="va">{{
                      (jinNangDetail.totalAmount / 10000.0).toFixed(2)
                    }}</span>
                  </div>
                  <div>
                    <span class="ti">可用</span>
                    <span>{{
                      (jinNangDetail.avaliableAmount / 10000.0).toFixed(2)
                    }}</span>
                  </div>
                </div>
                <div class="summary-item">
                  <div>
                    <span class="ti">账户市值</span>
                    <span class="va">{{
                      (jinNangDetail.marketValueAmount / 10000.0).toFixed(2)
                    }}</span>
                  </div>
                  <div>
                    <span class="ti">仓位</span>
                    <span>{{ jinNangDetail.totalPosition }}</span>
                  </div>
                </div>
              </div>

              <div class="trade-item-table">
                <div class="table-row table-head">
                  <div>序号</div>
                  <div>名称</div>
                  <div>持仓/可用</div>
                  <div>现价/成本</div>
                  <div>持仓盈亏</div>
                  <div>持仓比例</div>
                </div>
                <div
                  v-for="(item, index) in this.repoList"
                  :key="index"
                  class="table-row"
                >
                  <div>
                    <div class="row-index">{{ item.idx }}</div>
                  </div>
                  <div>
                    <div>{{ item.securitiesName }}</div>
                    <div>{{ item.securitiesCode }}</div>
                  </div>
                  <div>
                    <div>{{ item.secuAmountStr }}</div>
                    <div class="color-858585">{{ item.usableAmountStr }}</div>
                  </div>
                  <div>
                    <div>{{ item.newPriceStr }}</div>
                    <div>{{ item.dilucostPriceStr }}</div>
                  </div>
                  <div>
                    <div
                      :class="getSymbol(item.gainLossScale) > 0 ? 'c1' : 'c3'"
                    >
                      {{ item.gainLossScale }}
                    </div>
                    <div
                      :class="getSymbol(item.totalGailLoss) > 0 ? 'c1' : 'c3'"
                    >
                      {{ item.totalGailLoss / 10000.0 }}
                    </div>
                  </div>
                  <div>
                    <div>{{ toPercent(item.secuScale / 10000.0) }}</div>
                  </div>
                </div>
              </div>

              <!-- 仓位配置 -->
              <div class="repo-chart-title">仓位配置</div>
              <div id="repoChart" class="repo-chart"></div>
            </div>
          </div>
        </div>
        <div class="side-content">
          <!-- 作者信息-->
          <author-info-panel :authorInfo="authorInfo"></author-info-panel>

          <!-- 个人介绍-->
          <personal-description-panel
            :description="authorInfo.remark ? authorInfo.remark : ''"
          ></personal-description-panel>

          <!-- <jin-nang-panel :jinNangList="jinNangList" title="他的热卖锦囊"></jin-nang-panel> -->
          <dian-jin-panel
            :dianJinList="dianJinList"
            :title="dianjinPanelTitle"
          ></dian-jin-panel>

          <!-- <course-panel :courseList="courseList" :title="coursePanelTitle"></course-panel> -->
        </div>
      </div>
      <div class="float-bar" v-if="isFixed">
        <div class="bar-remain">
          剩余
          <span>{{ jinNangDetail.leftServiceNum }}</span
          >份
        </div>
        <div class="bar-price">¥{{ jinNangDetail.price }}</div>
        <div class="bar-buy" @click="buyclick">立即订购</div>
      </div>
    </template>
  </div>
</template>

<script>
import { getDianjinList } from '@/api/dianjin'
import {
  getJinNangDetail,
  getJinNangTradePage,
  getJinNangRepoList,
  getJinNangYieldList
} from '@/api/jinNang'
import {
  // getCourseList,
  // getHotSaledJinNangList,
  getAuthorDetail
} from '@/api/author'
// import JinNangPanel from '@/components/JinNangPanel/JinNangPanel'
import DianJinPanel from '@/components/DianJinPanel/DianJinPanel'
// import CoursePanel from '@/components/CoursePanel/CoursePanel'
import dayjs from 'dayjs'
import PersonalDescriptionPanel from '@/components/PersonalDescriptionPanel/PersonalDescriptionPanel'
import AuthorInfoPanel from '@/components/AuthorInfoPanel/AuthorInfoPanel'

export default {
  name: 'JinNangDetail',
  components: {
    // JinNangPanel,
    DianJinPanel,
    // CoursePanel,
    AuthorInfoPanel,
    PersonalDescriptionPanel
  },
  data() {
    return {
      authorId: '',
      dianJinList: [],
      courseList: [],
      dianjinPanelTitle: '他的点金',
      coursePanelTitle: '他的课程',
      jinNangDetail: {},
      currentRangeFilterIndex: 0,
      currentTabIndex: 0,
      tradeFilter: ['交易动态', '持仓明细'],
      chartFilter: [
        { text: '一月' },
        { text: '三月' },
        { text: '一年' },
        { text: '今年以来' },
        { text: '创建以来' }
      ],
      viewState: '',
      pageEnd: true,
      tradeList: [],
      repoList: [],
      YieldList: [],
      jinNangList: [],
      isFixed: false,
      authorInfo: {}
    }
  },
  computed: {
    jinNangId() {
      return this.$route.params.id
    }
  },
  watch: {
    async currentRangeFilterIndex(newValue, oldValue) {
      await this.getYieldList(this.getFilterRange(newValue))
    }
  },
  created() {
    this.getJinNangPage().then(() => {
      this.getAuthorDetail()
    })
    window.addEventListener('scroll', this.handleScroll)
  },
  methods: {
    dayjs,
    // 监听滚动处理函数
    handleScroll() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop
      if (scrollTop >= 200) {
        this.isFixed = true
      } else {
        this.isFixed = false
      }
    },
    changeVideo(index) {
      this.activeVideoIndex = index

      this.$nextTick(this.getPlayInfo())
    },
    getSymbol(number) {
      const dig = parseFloat(number)
      return dig
    },
    async getAuthorDetail() {
      this.authorInfo = await getAuthorDetail(this.authorId)
    },
    async getJinNangPage() {
      this.jinNangDetail = await getJinNangDetail({
        jinNangId: this.jinNangId
      })
      this.authorId = this.jinNangDetail.authorId
      await this.getTradePage()
      await this.getJinNangRepoList()
      await this.getYieldList(this.getFilterRange(this.currentRangeFilterIndex))
      // await this.getCourseList()
      await this.getDianJinList()
      // await this.getHotJinNangList()
    },
    async getTradePage() {
      const data = await getJinNangTradePage(
        {
          jinNangId: this.jinNangId,
          Filter: 1,
          direction: this.viewState ? 2 : 0
        },
        this.viewState
      )
      if (data) {
        if (data.result.code === 0) {
          this.viewState = data.result.viewState
          this.pageEnd = data.detail.end
          if (data.detail.flush) {
            this.tradeList = data.detail.list
          } else {
            this.tradeList = this.tradeList.concat(data.detail.list)
          }
        }
      }
    },
    async getJinNangRepoList() {
      const data = await getJinNangRepoList({
        jinNangId: this.jinNangId
      })
      if (data) {
        if (data.result.code === 0) {
          this.repoList = data.detail.items
          this.renderRepoChart(this.repoList)
        }
      }
    },
    async getDianJinList() {
      const data = await getDianjinList({
        authorId: this.authorId
      })
      if (data) {
        if (data.result.code === 0) {
          this.dianJinList =
            data.detail.list.length > 5
              ? data.detail.list.slice(0, 4)
              : data.detail.list
        }
      }
    },
    // async getCourseList() {
    //   const data = await getCourseList({
    //     authorId: this.authorId
    //   })
    //   if (data) {
    //     this.courseList =
    //       data.list.length > 5 ? data.list.slice(0, 4) : data.list
    //   }
    // },
    async getYieldList(range) {
      const data = await getJinNangYieldList({
        jinNangId: this.jinNangId,
        range: range,
        type: 1,
        pageSize: 1000
      })
      if (data) {
        if (data.result.code === 0) {
          this.YieldList = data.detail
          this.renderYieldChart(this.YieldList.items)
        }
      }
    },
    // async getHotJinNangList() {
    //   const data = await getHotSaledJinNangList({
    //     authorId: this.authorId,
    //     limit: 4
    //   })
    //   if (data) {
    //     this.jinNangList = data
    //   }
    // },
    buyclick() {
      this.$store.dispatch('cashierDesk/openGoodsAction', {
        setId: this.jinNangDetail.goodsSetId,
        goodsId: 0,
        orderId: ''
      })
    },
    groupBy(list, keyGetter) {
      const map = new Map()
      list.forEach(item => {
        const key = keyGetter(item)
        const collection = map.get(key)
        if (!collection) {
          map.set(key, [item])
        } else {
          collection.push(item)
        }
      })
      return map
    },
    toPercent(point) {
      var str = Number(point * 100).toFixed(1)
      str += '%'
      return str
    },
    selectTradeFilter(index) {
      this.currentTabIndex = index
    },
    selectRange(index) {
      this.currentRangeFilterIndex = index
    },
    getFilterRange(index) {
      var now = this.dayjs()
      if (index === 0) {
        return parseInt(now.subtract(1, 'month').format('YYYYMMDD'))
      } else if (index === 1) {
        return parseInt(now.subtract(3, 'month').format('YYYYMMDD'))
      } else if (index === 2) {
        return parseInt(now.subtract(1, 'year').format('YYYYMMDD'))
      } else if (index === 3) {
        return parseInt(now.startOf('year').format('YYYYMMDD'))
      } else {
        return 0
      }
    },
    renderYieldChart(sourceData) {
      var yieldChart = this.$echarts.init(document.getElementById('yieldChart'))
      var glYieldSeriesDataArr = sourceData.map(a => a.glYield / 100.0)
      var indexSeriesDataArr = sourceData.map(a => a.indexYield / 100.0)
      var xaxisData = sourceData.map(a =>
        a.tradeDate
          .toString()
          .split('')
          .slice(4, 6)
          .concat(['-'])
          .concat(
            a.tradeDate
              .toString()
              .split('')
              .slice(6)
          )
          .join('')
      )
      var option = {
        tooltip: {
          trigger: 'axis',
          formatter: '{a0}: {c0}%<br />{a1}: {c1}%',
          axisPointer: {
            type: 'cross'
          }
        },
        legend: {
          data: [
            {
              name: this.jinNangDetail.jinNangName,
              icon: 'RoundRect'
            },
            {
              name: '沪深300',
              icon: 'RoundRect'
            }
          ],
          top: '4%',
          right: '2%'
        },
        grid: {
          containLabel: true,
          left: '3%',
          right: '4%',
          bottom: '1%'
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: xaxisData
        },
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              show: true,
              interval: 'auto',
              formatter: '{value} %'
            },
            show: true
          }
        ],
        series: [
          {
            name: this.jinNangDetail.jinNangName,
            type: 'line',
            data: glYieldSeriesDataArr,
            color: 'rgb(4,107,204)',
            areaStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: 'rgba(4, 107, 204, 0.2)' // 0% 处的颜色
                  },
                  {
                    offset: 1,
                    color: 'transparent' // 100% 处的颜色
                  }
                ],
                global: false // 缺省为 false
              }
            }
          },
          {
            name: '沪深300',
            type: 'line',
            color: 'rgb(230,83,5)',
            data: indexSeriesDataArr
          }
        ]
      }
      yieldChart.setOption(option)
    },
    renderRepoChart(sourceData) {
      var yieldChart = this.$echarts.init(document.getElementById('repoChart'))
      var industryGroup = this.groupBy(sourceData, x => x.industryName)
      var seriesData = []
      const legendData = []
      let allSumVal = 0

      industryGroup.forEach((val, key) => {
        legendData.push(key)

        var sumVal = val.reduce(
          (pre, cur) => pre + cur.marketValue / 10000.0,
          0
        )
        seriesData.push({
          value: sumVal,
          name: key
        })
      })

      allSumVal = seriesData.reduce((pre, cur) => pre + cur.value, 0)
      var option = {
        tooltip: {
          trigger: 'item',
          formatter: '{b}:{d}%'
        },
        legend: {
          data: legendData,
          top: 'middle',
          orient: 'vertical',
          right: '20%',
          icon: 'circle',
          formatter: name => {
            var val = seriesData.find(a => a.name === name).value
            // 拼接全角空白符，为了使百分比对齐
            var emtpy = new Array(10 - name.length).join('　')
            return name + emtpy + ((val / allSumVal) * 100).toFixed(2) + '%'
          },
          textStyle: {
            fontSize: 16,
            color: 'rgba(38,38,38,1.000)'
          }
        },
        graphic: {
          type: 'text',
          left: '27%',
          top: 'center',
          style: {
            text: '总仓位' + '\n' + this.jinNangDetail.totalPosition,
            textAlign: 'center',
            fill: '#000',
            width: 30,
            height: 30,
            fontSize: 16
          }
        },
        series: [
          {
            type: 'pie',
            radius: ['30%', '70%'],
            avoidLabelOverlap: false,
            label: {
              show: false,
              position: 'center'
            },
            emphasis: {
              label: {
                show: false
              }
            },
            labelLine: {
              show: false
            },
            data: seriesData,
            center: ['30%', '50%']
          }
        ]
      }

      yieldChart.setOption(option)
    }
  }
}
</script>

<style lang="scss" scoped>
.wrapper {
  display: flex;
  margin-top: 30px;
}

.jinNang-detail {
  padding-top: 40px;
  position: relative;
}

.content {
  flex: auto;
  display: flex;
  flex-direction: column;
}

.main-content {
  display: flex;
  flex: auto;
  flex-direction: column;
}

.side-content {
  margin-left: 40px;
}

.basic-item {
  border-top: 2px solid #ebebeb;
  padding: 30px 0;
  position: relative;
}

.title {
  font-size: 20px;
  letter-spacing: 1px;
  color: #262626;
}

.time {
  margin-top: 20px;
  font-size: 14px;
  color: #858585;
  letter-spacing: 1px;
}

.sale {
  display: flex;
  align-items: center;
  position: absolute;
  right: 0px;
  top: 40px;
}

.price {
  font-size: 14px;
  letter-spacing: 1px;
  color: #e64c2e;
}

.buy {
  background-color: #e64c2e;
  border-radius: 18px;
  margin-left: 20px;
  font-size: 16px;
  letter-spacing: 1px;
  color: #ffffff;
  padding: 10px 18px;
  cursor: pointer;
}

.subTitle {
  font-size: 16px;
  letter-spacing: 1px;
  color: #262626;
}

.btn-group {
  margin-top: 40px;
  letter-spacing: 1px;
  color: #858585;
  display: flex;
}

.btn {
  padding: 8px 18px;
  background-color: #f0f0f0;
  border-radius: 2px;
  font-size: 14px;
}

.btn-first {
  margin-right: 20px;
}

.chu {
  font-size: 18px;
  color: #ffffff;
  padding: 2px;
  background-image: linear-gradient(0deg, #f23000 0%, #ff8566 100%),
    linear-gradient(#ff5c33, #ff5c33);
  border-radius: 0px 4px 0px 4px;
  margin-right: 10px;
}

.jin {
  font-size: 18px;
  color: #ffffff;
  padding: 2px;
  background-image: linear-gradient(0deg, #006df2 0%, #66abff 100%),
    linear-gradient(#338fff, #338fff);
  border-radius: 0px 4px 0px 4px;
  margin-right: 10px;
}

.subTitle > :nth-child(2) {
  margin-right: 62px;
}

.card {
  display: flex;
  margin-top: 40px;
  justify-content: center;
}

.card-item {
  width: 242px;
  height: 100px;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  background-color: rgba($color: #e64c2e, $alpha: 0.1);
  border-radius: 5px;
  margin-right: 50px;
  font-size: 16px;
  letter-spacing: 1px;
  color: #262626;
}

.card-item:last-child {
  margin-right: 0;
}

.greenbj {
  background-color: rgba($color: #38bf26, $alpha: 0.1);
}

.card-item > :nth-child(2) {
  font-size: 20px;
  letter-spacing: 1px;
  margin-top: 18px;
}

.month > :nth-child(2) {
  font-size: 20px;
  margin-top: 18px;
}

.chart {
  margin-bottom: 40px;
}

.chart-content {
  height: 400px;
}

.chart-filter {
  display: flex;
}

.trade-filter {
  margin-top: 40px;
}

.filter-item {
  flex: 1 1 auto;
  border: 1px solid #858585;
  height: 36px;
  text-align: center;
  font-size: 16px;
  color: #262626;
  line-height: 36px;
  cursor: default;
}

.trade-filter {
  display: flex;
  justify-content: center;
  height: 70px;
}

.trade-filter-item {
  width: 160px;
  height: 35px;
  font-size: 16px;
  line-height: 35px;
  text-align: center;
  background-color: #fafafa;
  border: solid 1px #858585;
  cursor: default;
}

.filter-select {
  background-color: #046bcc;
  color: #fffefe;
}

.repo-summary {
  padding: 28px 0 8px 0;
  border-top: 2px solid #ebebeb;
  font-size: 16px;
  display: flex;
}

.summary-item {
  margin: 12px 0;
  display: flex;
  flex-basis: 250px;
  flex-direction: column;
}

.summary-item > div {
  margin-bottom: 20px;
}

.summary-item .ti {
  letter-spacing: 1px;
  color: #858585;
  margin-right: 5px;
}

.summary-item .va {
  color: #262626;
}

.trade-item-table {
  font-size: 16px;
  letter-spacing: 1px;
  color: #262626;
  margin-bottom: 40px;
}

.trade-item-table > :nth-child(odd) {
  background-color: #fafafa;
}

.table-row {
  display: flex;
  height: 90px;
  font-size: 16px;
  color: #262626;
  justify-content: center;
}

.table-head {
  height: 40px;
  color: #858585;
}

.row-index {
  padding: 5px 8px;
  background-color: #046bcc;
  border-radius: 3px 8px 3px 8px;
  font-size: 14px;
  color: #ffffff;
}

.row-in {
  padding: 5px 8px;
  background-color: #e64c2e;
  border-radius: 3px 8px 3px 8px;
  font-size: 14px;
  color: #ffffff;
}

.row-out {
  padding: 5px 8px;
  background-color: #38bf26;
  border-radius: 3px 8px 3px 8px;
  font-size: 14px;
  color: #ffffff;
}

.table-row > div {
  flex: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  align-content: center;
  flex-basis: 100px;
}

.repo-chart-title {
  font-size: 16px;
  line-height: 16px;
  color: #262626;
}

.repo-chart {
  height: 300px;
  width: 826px;
}

.float-bar {
  display: flex;
  width: 1200px;
  height: 80px;
  font-size: 16px;
  align-items: center;
  position: fixed;
  top: 100px;
  left: 0;
  right: 0;
  margin: 0 auto;
  background-color: #ffffff;
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.1);
  border-radius: 5px;
}

.bar-price {
  letter-spacing: 1px;
  color: #e64c2e;
  flex: none;
}

.bar-buy {
  background-color: #e64c2e;
  border-radius: 24px;
  margin-left: 30px;
  font-size: 16px;
  letter-spacing: 1px;
  color: #ffffff;
  padding: 16px 49px;
  cursor: pointer;
}

.bar-remain {
  flex: auto;
  margin-left: 30px;
}

.bar-remain > span {
  margin: 0 3px;
  color: #858585;
}

.color-858585 {
  color: #858585;
}

.color-262626 {
  color: #262626;
}

.color-e64c2e {
  color: #e64c2e;
}

.more {
  width: 828px;
  height: 40px;
  margin: 30px auto;
  font-size: 14px;
  line-height: 40px;
  color: #858585;
  background-color: #fafafa;
  text-align: center;
  cursor: pointer;
}
</style>
